// extracted by mini-css-extract-plugin
export var askAiIcon = "_ne-j";
export var category = "_ne-9";
export var categoryHeader = "_ne-e";
export var container = "_ne-0";
export var group = "_ne-a";
export var groupItems = "_ne-f";
export var groupSeparator = "_ne-k";
export var loading = "_ne-1";
export var noResults = "_ne-3";
export var placeholder = "_ne-2";
export var resultContent = "_ne-5";
export var resultIcon = "_ne-c";
export var resultItem = "_ne-g";
export var resultMeta = "_ne-8";
export var resultSubtitle = "_ne-7";
export var resultSuffix = "_ne-i";
export var resultTitle = "_ne-6";
export var resultsList = "_ne-4";
export var searchGroup = "_ne-d";
export var selected = "_ne-h";
export var subgroup = "_ne-b";